import { Row } from "antd";
import { colors } from "pages/Home/Home.styles";
import styled from "styled-components";

export const RowLayout = styled(({ ...rest }) => <Row {...rest} />)`
  padding: 40px 60px;
  background-image: ${({ image }) => ` url(${image})`};
  background-size: 60% 160%;
  background-position: 100% 0%;
  background-repeat: no-repeat;
  align-items: center;
  .COL-video {
    height: 500px;
  }
  .COL-descriptions {
    padding-left: 60px;
  }
  .text {
    margin-top: 50px;
    display: flex;
    row-gap: 30px;
    flex-direction: column;
  }
  .title {
    font-size: 28px;
    color: ${colors.green};
    font-weight: bold;
  }
  .description {
    font-size: 22px;
    color: ${colors.white};
    font-weight: semi-bold;
    font-weight: 500;
    span {
      font-weight: 900;
    }
  }
  @media (max-width: 770px) {
    .COL-descriptions {
      padding-left: 0px;
      padding-top: 20px;
    }
    .description {
      text-align: center;
    }
    .title {
      text-align: center;
    }
  }
`;
